// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseChecker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var RouteUtils = require('share/utils/Izenda.RouteUtils');
  const { isNil, isFunction } = require('lodash/fp');

  function LicenseChecker(licenseKey, onLicense, BaseComponent) {
    var LicenseCheckerComponent = React.createClass({
      contextTypes: {
        authorization: React.PropTypes.object.isRequired
      },

      componentWillMount: function() {
        var hasLicense = this.context.authorization.checkLicense(licenseKey);

        if (!isFunction(onLicense)) {
          if (!isNil(hasLicense) && !hasLicense) {
            this.hasNoLicense = true;
            this.props.router.push(RouteUtils.getNoPermissionUrl());
          }
        } else {
          onLicense.call(null, hasLicense);
        }
      },

      render: function() {
        return !this.hasNoLicense && <BaseComponent {...this.props} />;
      }
    });

    return observer(LicenseCheckerComponent);
  }

  module.exports = LicenseChecker;
})();



// WEBPACK FOOTER //
// ./ui/share/components/hoc/Izenda.LicenseChecker.jsx